import * as React from "react";
import { forwardRef } from "react";
const SvgMoreOptionsWithPadding = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M36 127.312A1.687 1.687 0 1 1 37.688 129 1.686 1.686 0 0 1 36 127.312M36 120a1.687 1.687 0 1 1 1.688 1.688A1.686 1.686 0 0 1 36 120m0-7.312a1.687 1.687 0 1 1 1.688 1.688A1.687 1.687 0 0 1 36 112.688", "data-name": "icon/moreoptions", transform: "translate(-28.7 -111)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgMoreOptionsWithPadding);
export { ForwardRef as ReactComponent };
